import config from "../config/config";
import axios from "axios";

export default (queryParams = {}) => axios({
  method: "get",
  url: `${config.api.base_url}time/utc-time`,
  params: { ...queryParams },
  headers: { "Content-type": "application/json; charset=UTF-8" }
});
